module.exports = __webpack_public_path__ + "img/feat_4.32bcbb74.png";